import styled from 'styled-components';
import { lineHeight } from '../style';

export type GridLayoutProps = {
  space?: number;
  minSize?: number;
};

export const GridLayout = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(
      ${({ minSize = 12 * lineHeight }: GridLayoutProps) => minSize}px,
      1fr
    )
  );
  grid-template-rows: 1fr;
  gap: ${({ space = lineHeight }: GridLayoutProps) => space}px;
`;
